import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=7120df5a&scoped=true"
import script from "./Permission.vue?vue&type=script&lang=js"
export * from "./Permission.vue?vue&type=script&lang=js"
import style0 from "./Permission.vue?vue&type=style&index=0&id=7120df5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7120df5a",
  null
  
)

export default component.exports